<script setup lang="ts">
import { ref, onMounted } from 'vue'

const spriteUI = ref('')
const spriteFlags = ref('')
const spriteCards = ref('')
const spriteSocials = ref('')

onMounted(async () => {
  console.log('VITE_APP_BASE_URL', import.meta.env.VITE_APP_BASE_URL)
  const resUI = await fetch(`${import.meta.env.VITE_APP_BASE_URL}assets/svg/sprite-ui.svg`)
  spriteUI.value = await resUI.text()
  const resFlags = await fetch(`${import.meta.env.VITE_APP_BASE_URL}assets/svg/sprite-flags.svg`)
  spriteFlags.value = await resFlags.text()
  const resCards = await fetch(`${import.meta.env.VITE_APP_BASE_URL}assets/svg/sprite-cards.svg`)
  spriteCards.value = await resCards.text()
  const resSocials = await fetch(
    `${import.meta.env.VITE_APP_BASE_URL}assets/svg/sprite-socials.svg`
  )
  spriteSocials.value = await resSocials.text()
})
</script>

<template>
  <div
    v-html="spriteUI"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
  <div
    v-html="spriteFlags"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
  <div
    v-html="spriteCards"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
  <div
    v-html="spriteSocials"
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  ></div>
</template>
